import { Component } from '@angular/core';
import { CustomizedErrorStateMatcher } from '../../../state/custom.error-matcher';
import { ValidationService } from '../../services/validation.service';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-reject-dialog',
    templateUrl: './reject-dialog.component.html',
    styleUrls: ['./reject-dialog.component.scss'],
    standalone: false
})
export class RejectDialogComponent {
  matcher = new CustomizedErrorStateMatcher();
  rejectForm: UntypedFormGroup;

  constructor(
    public validationService: ValidationService,
    private dialogRef: MatDialogRef<RejectDialogComponent>
  ) {
    this.rejectForm = new UntypedFormGroup({
      comment: new UntypedFormControl('', [Validators.maxLength(1000)])
    });
  }

  get comment(): AbstractControl {
    return this.rejectForm.get('comment');
  }

  onConfirm(): void {
    this.dialogRef.close(this.comment.value);
  }
}
